<template>
    <div class="account">
        <div class="account-div">
            <div class="account-title">
                <img src="../assets/money-icon.png" alt="" />
                <span>账户充值</span>
            </div>
            <div class="account-money">
                <div class="money-left">
                    <div class="left-title">充值方式</div>
                    <div class="left-way">
                        <div :class="isPay == item.id ? 'way-but' : 'nway-but'" @click="tabPay(item.id)"
                            v-for="item in payWay" :key="item.id">
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div class="money-right">
                    <div class="right-title">选择充值套餐</div>
                    <div class="right-box">
                        <div class="money-list">
                            <div :class="payId == item.id ? 'num-box newNumBox' : 'num-box'" @click="payDialog(item.id)"
                                v-for="item in tpaysetData" :key="item.id">
                                <div class="num-title">
                                    <span>{{ item.energy }}</span>
                                    <img src="../assets/money-blood.png" alt="" />
                                </div>
                                <div class="num-pay">¥ {{ item.cny }}</div>
                                <img class="xuan" src="../assets/money-gou.png" alt="" v-if="payId == item.id" />
                            </div>
                        </div>
                        <div class="ins-box">
                            <p class="ins-title">充值说明：</p>
                            <p class="ins-text">
                                您充值的物品为{{type=='b'?'伴伴直播':'掌控娱乐'}}账户余额，充值后需要在{{type=='b'?'伴伴直播':'掌控娱乐'}}APP中进行消费。<br />
                                充值余额前需登录{{type=='b'?'伴伴直播':'掌控娱乐'}}账户，未登录用户无法进行充值。<br />
                                对充值过程有任何不解的疑问，请通过顶部联系客服进行咨询。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="20%" :before-close="handleClose" :close-on-click-modal="false"
            class="dialog-style">
            <div class="dialog-box">
                <div class="dialog-title">扫码支付</div>
                <div class="dialog-num">需支付金额 <span>28元</span></div>
                <div class="dialog-code">二维码</div>
                <div class="dialog-time">
                    二维码有效期为<span>10分钟</span>，请尽快支付
                </div>
                <div class="dialog-but">刷新二维码</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    tpaysetlistApi, alipcpayApi, usercoinApi
} from "../api/api.js";
export default {
    name: "Account",
    data() {
        return {
            dialogVisible: false,
            isPay: 2,
            payId: '',
            payWay: [
                // {
                //     id: 1,
                //     value: "微信支付",
                // },
                {
                    id: 2,
                    value: "支付宝支付",
                },
            ],
            tpaysetData: []
        };
    },
    components: {},
    computed:{
        type() {
            return window.location.hostname.indexOf('yaojing') >=0?'b':'z';
        }
    },
    mounted() {
        if (this.$store.getters.getToken) {
            this.tpaysetlist()
        }
    },
    methods: {
        payDialog(id) {
            // this.dialogVisible = true;
            this.payId = id
            this.alipcpay()
        },
        handleClose() {
            this.dialogVisible = false;
        },
        tabPay(id) {
            this.isPay = id;
        },
        async tpaysetlist() {
            const token = this.$store.getters.getToken
            const res = await tpaysetlistApi({
                token: token,
                pageIndex: 1,
                pageSize: 10,
                os: 'an'
            });
            this.tpaysetData = res.data.data.records
            this.payId = res.data.data.records[0].id
        },
        // async alipcpay() {
        //     const token = this.$store.getters.getToken
        //     const res = await alipcpayApi({
        //         token,
        //         payId: this.payId
        //     })
        //     console.log(res, '-----------');

        // }
        alipcpay() {
            const token = this.$store.getters.getToken
            window.open(`http://apione.zhangkongyl.cn:9016/pay/alipcpay?token=${token}&payId=${this.payId}`)
        }
    },
};
</script>
<style lang="scss" scoped>
.account {
    width: 100vw;
    height: 1403px;
    background: url("../assets/active-bg.png");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}

.account-div {
    width: 70%;
    height: 1144px;

    .account-title {
        height: 5%;
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        // padding-bottom: 20px;
        border-bottom: 1px solid #6d6d6d;

        img {
            width: 43px;
            padding-right: 10px;
        }

        span {
            font-size: 18px;
            color: #000;
            font-weight: bold;
        }
    }

    .account-money {
        width: 100%;
        height: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .money-left {
            width: 20%;
            height: 100%;

            .left-title {
                height: 8%;
                font-size: 26px;
                font-weight: bold;
                background: #cccccc;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .left-way {
                cursor: pointer;

                .way-but {
                    width: 80%;
                    padding: 20px 0;
                    margin: 30px auto;
                    background: #ff9000;
                    color: #fff;
                    font-size: 18px;
                    border-radius: 5px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .nway-but {
                    width: 80%;
                    padding: 20px 0;
                    margin: 30px auto;
                    background: #505050;
                    color: #fff;
                    font-size: 18px;
                    border-radius: 5px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .money-right {
            width: 77%;
            height: 100%;

            .right-title {
                height: 8%;
                font-size: 26px;
                font-weight: bold;
                background: #cccccc;
                display: flex;
                align-items: center;
                padding-left: 50px;
            }

            .right-box {
                width: 100%;
                height: 92%;
                background: rgb(234, 234, 234, 0.7);

                .money-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 20px;

                    .num-box {
                        width: 15%;
                        border: 1px solid #8d8d8d;
                        // #FF9000
                        padding: 0 30px;
                        border-radius: 16px;
                        margin: 10px 20px;
                        position: relative;
                        cursor: pointer;

                        .num-title {
                            text-align: center;
                            padding: 30px 0;
                            border-bottom: 1px dashed #919191;

                            span {
                                font-size: 36px;
                                font-weight: bold;
                                padding-right: 5px;
                            }

                            img {
                                width: 30px;
                            }
                        }

                        .num-pay {
                            color: #8d8d8d;
                            font-size: 24px;
                            text-align: center;
                            padding: 25px 0;
                        }

                        .xuan {
                            position: absolute;
                            right: 0;
                            top: 0;
                            width: 60px;
                        }
                    }

                    .newNumBox {
                        border: 1px solid #ff9000;
                    }
                }

                .ins-box {
                    padding-top: 150px;
                    padding-left: 50px;

                    .ins-title {
                        font-size: 24px;
                        font-weight: bold;
                        color: #000;
                        padding-bottom: 10px;
                    }

                    .ins-text {
                        color: #7d7d7d;
                        font-size: 16px;
                        line-height: 25px;
                    }
                }
            }
        }
    }
}

.dialog-box {
    text-align: center;

    .dialog-title {
        color: #000000;
        font-size: 22px;
        font-weight: bold;
    }

    .dialog-num {
        color: #9a9a9a;
        font-size: 16px;
        padding: 15px 0;

        span {
            color: red;
            font-weight: bold;
        }
    }

    .dialog-code {
        width: 200px;
        height: 200px;
        background: pink;
        margin: 0 auto;
    }

    .dialog-time {
        color: #9a9a9a;
        font-size: 14px;
        padding: 15px 0;

        span {
            color: red;
            font-weight: bold;
        }
    }

    .dialog-but {
        width: 160px;
        height: 30px;
        margin: 0 auto;
        border: 1px solid #9a9a9a;
        color: #9a9a9a;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
</style>
